import { render } from "./TheStepSection.vue?vue&type=template&id=39a3eb52"
import script from "./TheStepSection.vue?vue&type=script&lang=js"
export * from "./TheStepSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__